import { render, staticRenderFns } from "./SwitchLegacy.vue?vue&type=template&id=7c700b96"
import script from "./SwitchLegacy.vue?vue&type=script&lang=js"
export * from "./SwitchLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports